import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

// Routes Universal Link / App Link cold-starts and warm-starts into React Router.
// When the OS launches Beacon via a https://<our-domain>/foo/bar URL, Capacitor
// fires appUrlOpen with the full URL — we strip the origin and hand the path to
// the router so the user lands on the right route.
export function useDeepLinkHandler() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    const subscription = App.addListener('appUrlOpen', event => {
      try {
        const url = new URL(event.url)
        const target = `${url.pathname}${url.search}${url.hash}`
        if (target && target !== '/') navigate(target)
      } catch {
        // Malformed URL — ignore rather than crash the listener.
      }
    })

    return () => {
      void subscription.then(s => s.remove())
    }
  }, [navigate])
}
